// @flow

const defaultLayoutUrls: {| [string]: string |} = {
  abuse: 'https://v4.gandi.net/abuse',
  admin: 'https://admin.gandi.net',
  shop: 'https://admin.gandi.net',
  account: 'https://account.gandi.net',
  id: 'https://id.gandi.net',
  login: '/support/api/v5/login', // pivoine login route,
  logout: '/support/api/v5/logout', // pivoine logout route
  docs: 'https://docs.gandi.net',
  news: 'https://news.beta.gandi.net',
  status: 'https://status.gandi.net',
  support: 'https://admin.local.gandi.net/support',
  public_site: 'https://beta.gandi.net',
  v4_prefix: 'https://www.gandi.net',
  v5_prefix: 'https://beta.gandi.net',
  webmail: 'https://webmail.gandi.net',
};

export default defaultLayoutUrls;
